import React from 'react';
import Modal from '../Modal';
import { actionOnCollectionPermissionError } from '../../queries/lightbox/CollectionUtil';

export default class ErrorModal extends React.Component {
  constructor() {
    super();
    this.handleCloseAction = this.handleCloseAction.bind(this);
  }
  handleCloseAction = () => {
    if (window.gs.onErrorCallBack) {
      window.gs.onErrorCallBack();
      window.gs.onErrorCallBack = null;
    }
    actionOnCollectionPermissionError();
  }
  render() {
    return (
      <Modal
        onClose={() => {
          window.setError(null);
          this.handleCloseAction();
        }}
        noAction={true}
        zIndex={1000}
        closeOnEsc
        closeOnOutsideClick>
        <div
          style={{
            margin: 'auto',
            background: 'var(--primary-style-color)',
            wordWrap: 'break-word',
            padding: '20px',
            fontSize: '20px',
            color: 'var(--primary-header-bg)'
          }}>
          {this.props.children}
        </div>
      </Modal>
    );
  }
}
